import { useEffect, useRef, useState } from 'react';
import "../../FormView.css";

import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useNavigate, useParams } from 'react-router-dom';
import { CustomOrderList } from '../../../../../../Shared/Components/CustomOrderList';
import { CustomPickList } from '../../../../../../Shared/Components/CustomPickList';
import { useToast } from '../../../../../../Shared/hook/useToast';
import { ImageSizeType, OfferItemsImageAndTimer, OfferUpdateImageAndTiner } from '../../../../Domain/Model/Offer';
import { OfferItemSlider } from '../../../../Domain/Model/OfferItemSlider';
import { Product } from '../../../../Domain/Model/Product';
import { Products } from '../../../../Domain/Model/Products';
import OffersPromoViewModel from '../../OffersPromoViewModel';


type Row = {
  imageOfferRowId?: string;
  rowNumber?: number;
  elements: any[];
}
interface Element{
    id: any;
    imageId: string,
    imageUrl: File | null,
    urlSingle: string,
    name?: string;
    description?: string;
    sizeName?: string;
    sizeWidth?: any
    colSize: string;
    numberSize?: number;
    imageSizeType?: number;
    customImage?: File | null;
    parentImageId?: any;
    isMobileVersion?: boolean
    imageOfferRowId?: string;
    typeOffer: number;
}
enum screenModeType {
  WEB = 1,
  TABLET = 2,
  MOBILE = 3
}
export const FormBuilderTypeOfferImage = () => {

  const { id } = useParams();
  // const toast = useRef(null);
  const { showSuccess, showError, showWarn, showInfo } = useToast();
  const [elementsOb, setElementsOb] = useState<Element[]>([]);
  const [targetElements, setTargetElements] = useState<Element[]>([]);

  const [draggedItem, setDraggedItem] = useState<Element | null>(null);
  const [draggedRowItem, setDraggedRowItem] = useState<Row | null>(null);

  const [draggedTargetItem, setDraggedTargetItem] = useState<Element | null>(null);
  const [draggedTargetRowItem, setDraggedTargetRowItem] = useState<Row | null>(null);
  const [dragOverIndexRow, setDragOverIndexRow] = useState<number | null>(null);
  const [dragOverIndexElement, setDragOverIndexElement] = useState<number | null>(null);




  const [rows, setRows] = useState<Row[]>([
    {
      imageOfferRowId: crypto.randomUUID(),
      elements: []
    }
  ]);

  const title = "Tipo imágenes";
  const dropZoneRef = useRef<HTMLDivElement>(null);

  const [titleInput, setTitleInput] = useState<string>('');
  const [subtitleInput, setSubtitleInput] = useState<string>('');

  const [isDraggingElements, setIsDraggingElements] = useState(false);

  const elementInputRefs = useRef<{ [imageOfferRowId: string]: (HTMLInputElement | null)[] }>({});
  const [previousViewState, setPreviousViewState] = useState(false);
  const [screenMode, setScreenMode] = useState(screenModeType.WEB);

  const [canSave, setCanSave] = useState(true);

  const [visibleModal, setVisibleModal] = useState<boolean>(false);
  
  // estados para el update
  const [rowsModified, setRowsModified] = useState<any[]>([]);
  const [rowsToAdd, setRowsToAdd] = useState<Row[]>([]);
  const [itemsModified, setItemsModified] = useState<any[]>([]);
  const [itemToAdd, setItemToAdd] = useState<any[]>([]);
  

  const [customFile, setCustomFile] = useState<any>([]);
  
  
  
  

  const navigate = useNavigate();

  // Datos iniciales
  const elementData: Element[] = [
    {
        "id": 1,
        "imageId": "",
        "imageUrl": null,
        "urlSingle": "",
        "name": "Imagen Cuadrado pequeña",
        "description": "solo valido (PNG,JPG,JPEG)",
        "sizeName": "400 x 400",
        "colSize": "col-lg-3",
        "numberSize": 3,
        "imageSizeType": ImageSizeType.EC44,
        "customImage": null,
        "sizeWidth": "200px",
        "parentImageId":null,
        "isMobileVersion": false,
        "typeOffer": 3
    },
     {
        "id": 2,
        "imageId": "",
        "imageUrl": null,
        "urlSingle": "",
        "name": "Imagen Cuadrado mediana",
        "description": "solo valido (PNG,JPG,JPEG)",
        "sizeName": "600 x 600",
        "colSize": "col-lg-4",
        "numberSize": 4,
        "imageSizeType": ImageSizeType.EC66,
        "customImage": null,
        "sizeWidth": "200px",
        "parentImageId":null,
        "isMobileVersion": false,
        "typeOffer": 3
    },
    {
        "id": 3,
        "imageId": "",
        "imageUrl": null,
        "urlSingle": "",
        "name": "Imagen rectangular",
        "description": "solo valido (PNG,JPG,JPEG)",
        "sizeName": "800 x 400",
        "colSize": "col-lg-6",
        "numberSize": 6,
        "imageSizeType": ImageSizeType.ER84,
        "customImage": null,
        "sizeWidth": "120px",
        "parentImageId":null,
        "isMobileVersion": false,
        "typeOffer": 3

    },
    {
        "id": 4,
        "imageId": "",
        "imageUrl": null,
        "urlSingle": "",
        "name": "Imagen completa",
        "description": "solo valido (PNG,JPG,JPEG)",
        "sizeName": "1600 x 400",
        "colSize": "col-lg-12",
        "numberSize": 12,
        "imageSizeType": ImageSizeType.ER14,
        "customImage": null,
        "sizeWidth": "70px",
        "parentImageId":null,
        "isMobileVersion": false,
        "typeOffer": 3

    }
  ];

  const {
      getProducts,
      products,
      createOffer,
      getImagesById,
      removeOfferRow,
      removeOfferItem,
      updateItemOffer,
      updateOfferImages,
      updateOfferList,
      updateOfferSingle,
      getOfferItemSliderById
  } = OffersPromoViewModel();


  useEffect(() => {
    const allImagesAttached = rows.every(row =>
    row.elements.length > 0 && row.elements.every(el =>
        el.imageUrl &&
        (
          typeof el.imageUrl === "string"
            ? el.imageUrl.trim() !== "" // si es string, que no esté vacío
            : el.imageUrl instanceof File // si es File, que exista
        )
      )
  );
    setCanSave(!allImagesAttached);
  }, [rows]);

  useEffect(() => {
    setElementsOb(elementData);
  }, []);

  useEffect(() => {
    if(id){
      fetchAndSetOffer();
    }
  }, [id]);

  // useEffect(() => {
  //   console.log("rows cargados...", rows);
  // }, [rows]);

  // useEffect(() => {
  //   console.log("rowsModified cargados...", rowsModified);
  // }, [rowsModified]);

  // useEffect(() => {
  //   console.log("rowsToAdd cargados...", rowsToAdd);
  // }, [rowsToAdd]);

  // useEffect(() => {
  //   console.log("itemsModified cargados...", itemsModified);
  // }, [itemsModified]);

  // useEffect(() => {
  //   console.log("customFile", customFile);
  // }, [customFile]);

  // useEffect(() => {
  //   console.log("itemToAdd", itemToAdd);
  // }, [itemToAdd]);

  

  // Drag desde el panel lateral
  const handleDragStart = (element: Element, e: React.DragEvent) => {
    setDraggedItem(element);
  };


   //Drag desde los elementos en el target
  const handleTargetDragStart = ( e: React.DragEvent, element: Element) => {
    // console.log('drag start', element);
    e.dataTransfer.setData('application/json', element.imageId);
    setDraggedTargetItem(element);
  };

  const handleDragOverElement = (e: React.DragEvent, index?: number) => {
    e.preventDefault();
    if (index !== undefined) {
      setDragOverIndexElement(index);
    }
  };

  const handleDragLeaveElement = () => {
    setDragOverIndexElement(null);
  };
   
   const handleTargetDragStartRow = (e: React.DragEvent, row: Row, ) => {
     e.dataTransfer.setData('text/plain', row.imageOfferRowId ?? "");
    setDraggedTargetRowItem(row);
     
  };

  const handleDragOverRow = (e: React.DragEvent, index?: number) => {
    e.preventDefault();
    if (index !== undefined) {
      setDragOverIndexRow(index);
    }
  };

  // const handleDragLeave = () => {
  //   setDragOverIndexRow(null);
  // };

const addRow = () => {

   const newRow = {
    imageOfferRowId: crypto.randomUUID(),
    elements: []
  };

  // Actualizas rows con la nueva fila
  setRows(prevRows => [...prevRows, newRow]);

  // Y rowsToAdd SOLO con esta nueva fila
  setRowsToAdd(prevRows => [...prevRows, newRow]);

};


const removeRow = async (imageOfferRowId: string) => {
  const row = customFile.find(
    (m: { imageOfferRowId: string }) => m.imageOfferRowId === imageOfferRowId
  );

  if (!row) {
    console.warn("No se encontró la fila con ese imageOfferRowId");
    setRows((prevRows) =>
    prevRows.filter((row) => row.imageOfferRowId !== imageOfferRowId)
  );
    return;
  }

  if (id) {
    const deleted = await removeOfferRow(Number(id), row.imageOfferRowId);
    if (deleted) {
      showSuccess("Se registró", "Se ha eliminado con éxito!");
    }
  }

  setRows((prevRows) =>
    prevRows.filter((row) => row.imageOfferRowId !== imageOfferRowId)
  );
};

const removeElement = async (imageOfferRowId: string, elementId: string, idElement: number) => {

  if(id){

    if(idElement!=null){
      const deleted = await removeOfferItem(imageOfferRowId, idElement);
  
      if(deleted){
        showSuccess("Se registro", "Se ha eliminado con éxito!");
      }
    }
  }

  setRows(prevRows =>
    prevRows.map(row =>
      row.imageOfferRowId === imageOfferRowId
        ? {
            ...row,
            elements: deleteElementPair(row.elements, elementId),
            //elements: row.elements.filter(el => el.imageId !== elementId)
          }
        : row
    )
  );

  setItemToAdd(prevElements => prevElements.filter(el => el.imageId !== elementId));

  // setItemToAdd(element =>
  //   element.imageId === idElement
  //   deleteElementPair(row.elements, elementId),

  
  // );
};

const deleteElementPair = (elements: Element[], imageId: string) => {
  const elementToDelete = elements.find(el => el.imageId === imageId);
  if (!elementToDelete) return elements;

  // Si es un elemento principal ER14
  if (elementToDelete.imageSizeType === ImageSizeType.ER14 && !elementToDelete.isMobileVersion) {
    return elements.filter(el => 
      el.imageId !== imageId && el.parentImageId !== imageId
    );
  }
  
  // Si es un elemento mobile
  if (elementToDelete.isMobileVersion) {
    return elements.filter(el => 
      el.imageId !== imageId && el.imageId !== elementToDelete.parentImageId
    );
  }
  
  // Para elementos normales
  return elements.filter(el => el.imageId !== imageId);
};

  const handleDrop = (e: React.DragEvent, totalSize: number, imageOfferRowId?: string, elementIndex?: number, ) => {
    e.preventDefault();



    if (draggedItem && totalSize<12) {
      // Crear el elemento principal
      const imageIdUUID= crypto.randomUUID();
      //const imageOfferRowIdUUID = crypto.randomUUID();
      //let newElements = [];

      const mainElement = {
        ...draggedItem,
        id: null,
        imageId: imageIdUUID,
        imageUrl: null,
        imageOfferRowId: imageOfferRowId || crypto.randomUUID()
      };

      // Si es ER14, crear el elemento secundario para mobile
      if (draggedItem.imageSizeType === ImageSizeType.ER14) {

        const mobileElement = {
          ...draggedItem,
           id: null,
          imageId: crypto.randomUUID(),
          parentImageId: imageIdUUID,
          isMobileVersion: true,
          colSize: "col-lg-12",
          imageUrl: null
        };

        if (imageOfferRowId) {
          // Agregar a fila existente
          setRows(prevRows =>
            prevRows.map(row => {
              // const data =row;
              // setRowsToAdd(data);
              // console.log("RowsToAdd", rowsToAdd);
              return (
                row.imageOfferRowId === imageOfferRowId 
                  ? {
                      ...row,
                      elements: elementIndex !== undefined
                        ? [...row.elements.slice(0, elementIndex), mainElement, mobileElement, ...row.elements.slice(elementIndex)]
                        : [...row.elements, mainElement, mobileElement]
                    } 
                  : row
                )
              }
            )
          );
          if(Number(id)>0){
          
          setRowsToAdd(prevRows =>
            prevRows.map(row => {
              // const data =row;
              // setRowsToAdd(data);
              // console.log("RowsToAdd", rowsToAdd);
              return (
                row.imageOfferRowId === imageOfferRowId
                  ? {
                      ...row,
                      elements: elementIndex !== undefined
                        ? [...row.elements.slice(0, elementIndex), mainElement, mobileElement, ...row.elements.slice(elementIndex)]
                        : [...row.elements, mainElement, mobileElement]
                    } 
                  : row
                )
              }
            )
          );

          }
  
        }

      } else {

        setRows(prevRows =>
          prevRows.map(row =>{
            return (
              row.imageOfferRowId === imageOfferRowId 
                ? {
                    ...row,
                    elements: elementIndex !== undefined
                      ? [...row.elements.slice(0, elementIndex), mainElement, ...row.elements.slice(elementIndex)]
                      : [...row.elements, mainElement]
                  }
                : row
              )
            } 
          )
        );
        if(Number(id)>0){
          // guardar items nuevos añadidos a una fila existente

          setRowsToAdd(prevRows =>
            prevRows.map(row =>{
              return (
                row.imageOfferRowId === imageOfferRowId
                  ? {
                      ...row,
                      elements: elementIndex !== undefined
                        ? [...row.elements.slice(0, elementIndex), mainElement, ...row.elements.slice(elementIndex)]
                        : [...row.elements, mainElement]
                    }
                  : row
                )
              }
            )
          );

        const existingRowElement = customFile.find((m: { imageOfferRowId: any } ) => m.imageOfferRowId === mainElement.imageOfferRowId);

        if(!existingRowElement){
          console.log("no se encuentra la fila");
          return;
        }

        setItemToAdd(prevItem => [...prevItem, mainElement]);

          
          
        }
        
      }

      // setTargetElements(newElements);
      setDraggedItem(null);
    }

    if (draggedTargetRowItem){
      const draggedId = e.dataTransfer.getData('text/plain');

      const oldOrder = rows.map(r => r.imageOfferRowId); // snapshot antes del movimiento

      const fromIndex = rows.findIndex(item => item.imageOfferRowId === draggedId);
      
    if (fromIndex !== -1 && dragOverIndexRow !== null && fromIndex !== dragOverIndexRow) {

        const newRow = [...rows];
        const [removed] = newRow.splice(fromIndex, 1);
        newRow.splice(dragOverIndexRow, 0, removed);


        setRows(newRow);

      // registrar todos los que se movieron de lugar
      const batchChanges = newRow.reduce((acc, r, newIdx) => {
        const oldIdx = oldOrder.indexOf(r.imageOfferRowId);
        if (oldIdx !== newIdx) {
          acc.push({
            rowId: r.imageOfferRowId ?? "",
            oldIndex: oldIdx,
            newIndex: newIdx,
          });
        }
        return acc;
      }, [] as { rowId: string; oldIndex: number; newIndex: number }[]);

      // mergear al estado rowsModified
      setRowsModified(prev => {
        const map = new Map(prev.map(x => [x.rowId, x]));
        for (const c of batchChanges) {
          map.set(c.rowId, c);
        }
        return Array.from(map.values());
      });

        
      }

      setDraggedTargetRowItem(null);
      // console.log("rowsModified", rowsModified);
    }

    if (draggedTargetItem) {
      const draggedId = e.dataTransfer.getData('application/json');
      //const fromIndex = rows.findIndex(item => item.id === draggedId);
      
    
        const newRows = [...rows];
        

        const rowIndex = newRows.findIndex((r) => r.imageOfferRowId === imageOfferRowId); // identifica la fila

        if (rowIndex === -1) {
          alert("Fila no encontrada");
          return;
        }

        const row = newRows[rowIndex];

        // 1) Snapshot del orden ANTES de mover
        const oldOrder = row.elements.map(el => el.imageId);
        const fromIndexElement = row.elements.findIndex( (item) => item.imageId === draggedId);

        if (fromIndexElement !== -1 && dragOverIndexElement !== null && fromIndexElement !== dragOverIndexElement) {

            const newElements = [...row.elements]; // copia de los elementos de esa fila
            
            const [removed] = newElements.splice(fromIndexElement, 1); // quita el elemento
            newElements.splice(dragOverIndexElement, 0, removed); // lo inserta en nueva posición

            row.elements = newElements; // actualiza los elementos en la fila

            newRows[rowIndex] = row; // actualiza la fila en la lista

            setRows(newRows); // actualiza el estado

            const batchChanges = newElements.reduce((acc, el, newIdx) => {
            const oldIdx = oldOrder.indexOf(el.imageId); // <- usar snapshot
            if (oldIdx !== newIdx) {
              if(el.id !=null){
                acc.push({
                itemId: el.id,
                rowId: row.imageOfferRowId ?? "",
                oldIndex: oldIdx,
                newIndex: newIdx,
              });
              }
            }
            return acc;
          }, [] as { itemId: number; rowId: string; oldIndex: number; newIndex: number }[]);

          // 5) Merge al estado itemsModified (actualiza si ya existe, agrega si no)
          setItemsModified(prev => {
            const map = new Map(prev.map(x => [`${x.itemId}|${x.rowId}`, x]));
            for (const c of batchChanges) {
              map.set(`${c.itemId}|${c.rowId}`, c);
            }
            return Array.from(map.values());
          });

        }



      setDraggedTargetItem(null);
    }
    // Resto de tu lógica para nuevos elementos...
    setDragOverIndexRow(null);
    setDragOverIndexElement(null);
  };



  const RowComponent = ({ row}: { row: Row; }) => {
    const elementInputRefs = useRef<(HTMLInputElement | null)[]>([]);

     useEffect(() => {
        return () => {
          row.elements?.forEach(element => {
            if (element.imageUrl) {
              URL.revokeObjectURL(String(element.imageUrl));
            }
          });
        };
      }, [row.elements]);



 
  };

  const fetchAndSetOffer = async () => {
    try {
      const data = await getImagesById(Number(id)) as OfferUpdateImageAndTiner;

      if (data) {
        
        setTitleInput(data.Title);
        setSubtitleInput(data.SubTitle);

        const mapperRowData = mapperRow(data.rows);
        
        setRows(await mapperRowData);
        setCustomFile( await mapperRowData);

        // setRows(await data.rows);
        console.log("DATA OBTENIDA",data.rows );
      }
    
      if (!data) {
          throw new Error("No se encontraron datos del producto");
      }

    } catch (error) {
      console.error("Error en fetchAndSetImage:", error);
      // Mostrar notificación al usuario
      showError('Error','No se pudieron cargar las imágenes');
    }
  };

  const mapperRow = async (rowItem: any): Promise<Row[]> => {
    return Promise.all(
      rowItem.map(async (item: any) => {
        const elements = await mapOfferItemsToElements(item.offerItems);
        // console.log("elements", elements);
        return {
          imageOfferRowId: item.imageOfferRowId,
          elements
        };
      })
    );
  };

  function getNameAndMimeFromFilename(filename: string = "") {
  const parts = filename.split(".");
  if (parts.length < 2) {
    throw new Error("El nombre de archivo no tiene extensión");
  }
  
  const ext = parts.pop()?.toLowerCase(); // extensión sin el punto
  const nameImage = parts.join("."); // resto del nombre
  
  const mimeTypes: Record<string, string> = {
    png: "image/png",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    gif: "image/gif",
    webp: "image/webp"
  };
  
  const mimeType = mimeTypes[ext || ""] || "application/octet-stream";
  
  return { nameImage, ext, mimeType };
}

  const mapOfferItemsToElements = (offerItems: Array<OfferItemsImageAndTimer>): Promise<Element[]> => {
    return Promise.all(
      offerItems.map(async (item) => {

        const { nameImage, mimeType } = getNameAndMimeFromFilename(item.imageUrl);
        
          const imageUrl = item.imageUrl
          ? await urlToFile(item.imageUrl, `${nameImage}.${mimeType.split("/")[1]}`, mimeType)
          : null;

          let name="";
          const description="solo valido (PNG,JPG,JPEG,WEBP)";
          let sizeName="";
            
          if(item.imageSizeType === ImageSizeType.EC44) {
            name = "Imagen Cuadrado pequeña";
            sizeName = "400 x 400";
          } 
          if(item.imageSizeType === ImageSizeType.EC66) {
            name = "Imagen Cuadrado mediana";
            sizeName = "600 x 600";
          } 
          if(item.imageSizeType === ImageSizeType.ER84) {
            name = "Imagen Rectangular";
            sizeName = "800 x 400";
          } 
          if(item.imageSizeType === ImageSizeType.ER14) {
            name = "Imagen Completa";
            sizeName = "1600 x 400";
          }  
          
          return {
            id: item.id,
            imageId: item.imageId,
            urlSingle: item.urlSingle ?? "",
            imageSizeType: item.imageSizeType,
            colSize: item.colSize,
            imageUrl,
            name,
            description,
            sizeName,
            sizeWidth: "",
            parentImageId: item.parentImageId,
            isMobileVersion: item.isMobileVersion,
            imageOfferRowId: item.imageOfferRowId,
            typeOffer: item.typeOffer,
          };
        
      })
    );
  };

      

      // Función auxiliar para convertir URL a File
  const urlToFile = async (url: string, filename: string, mimeType: string): Promise<File> => {
      try {
          const response = await fetch(url);
          const blob = await response.blob();
          return new File([blob], filename, { type: mimeType });
      } catch (error) {
          console.error(`Error al convertir URL a File: ${url}`, error);
          throw error;
      }
  };

  // const show = ( severity: any, summary: any, detail: any,) => {
  //       // @ts-ignore
  //       toast.current.show({ severity: `${severity}`, summary: `${summary}`, detail: `${detail}`});
  //   };

  const handleDropImage = (e: React.DragEvent<HTMLDivElement>, elementIndex: number, imageOfferRowId: any, imageId:string) => {
        e.preventDefault();
        //e.stopPropagation();


        if (e.dataTransfer.files.length > 0) {

          const file = e.dataTransfer.files[0];
          if (file && file.type.startsWith("image/")) {
  
            // Validar tipo de archivo
            const validTypes = ['image/jpeg', 'image/png', 'image/jpg', "image/webp"];
            if (!validTypes.includes(file.type)) {
              showWarn('Error de formato', 'Solo se permiten imágenes JPEG, JPG, PNG, WEBP');
              return;
            }
            
            // Validar tamaño máximo (ejemplo: 2MB)
            const maxSize = 2 * 1024 * 1024;
            if (file.size > maxSize) {
              showWarn('Error de tamaño','La imagen es demasiado grande. Máximo 5MB');
              return;
            }

             setRows(prevRows =>
              prevRows.map(row =>
                row.imageOfferRowId === imageOfferRowId
                  ? {
                      ...row,
                      elements: row.elements.map((element, i) =>
                        i === elementIndex
                          ? { ...element, imageUrl: file }
                          : element
                      ),
                        
                    }
                  : row
              )
            );
            if(Number(id)>0){
              
              setRowsToAdd(prevRows =>
              prevRows.map(row =>
                row.imageOfferRowId === imageOfferRowId
                  ? {
                      ...row,
                      elements: row.elements.map((element, i) =>
                        i === elementIndex
                          ? { ...element, imageUrl: file }
                          : element
                      ),
                        
                    }
                  : row
              )
            );
             setItemToAdd(prevItem =>
              prevItem.map((element, i) =>
               {
                return element.imageId === imageId
                  ? { ...element, imageUrl: file }
                  : element
               }
              ));
            }
          }
        }

  };

     const updateItemImage = async (e: React.ChangeEvent<HTMLInputElement>, element: any) => {
      const file = e.target.files?.[0];
       let formData = new FormData();

        
      if(file){
         formData.append("Image", file);
      }
      
        const data = await updateItemOffer(element.id, formData);

        if(data){
          showSuccess("Se registro", "Se ha actualizado con éxito!");
        }
        
      
    }
    
    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>, elementIndex: number, imageOfferRowId: string, imageId: string) => {
        const file = e.target.files?.[0];
        if (file) {
            setRows(prevRows =>
              prevRows.map(row =>
                row.imageOfferRowId === imageOfferRowId 
                  ? {
                      ...row,
                      elements: row.elements.map((element, i) =>
                        i === elementIndex
                          ? { ...element, imageUrl: file }
                          : element
                      ),
                        
                    }
                  : row
              )
            );

            if(Number(id)>0){
              setRowsToAdd( prevRows =>
              prevRows.map( row =>
                row.imageOfferRowId === imageOfferRowId
                  ? {
                      ...row,
                      elements: row.elements.map((element, i) =>
                        i === elementIndex
                          ? { ...element, imageUrl: file }
                          : element
                      ),
                        
                    }
                  : row
              )
            );
            setItemToAdd(prevItem =>
              prevItem.map((element, i) =>
               {
                return element.imageId === imageId
                  ? { ...element, imageUrl: file }
                  : element
               }
              ));
            }
        }
    };
    
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
    
        let formData = new FormData();
        const typeOffer = 100;
        
        // 1. Añadir los campos de texto
        formData.append('title', titleInput);
        formData.append('subtitle', subtitleInput);
        formData.append('TypeOfferImages',typeOffer.toString());

        if(Number(id)>0){

          // console.log("rowsToAdd a enviar:", rowsToAdd);
          // console.log("rowsModified a enviar:", rowsModified);
          // console.log("itemsModified a enviar:", itemsModified);

          const renamedFile = (element: any)=> {
                const extension = element.imageUrl.name.split('.').pop();
                return new File(
                [element.imageUrl],
                `${element.imageId}.${extension}`,
                { type: element.imageUrl.type }
              );
            }

          const offerCustom: any = {rowsModified: [], itemsModified: [],  rowsToAdd: [], itemsToAdd: []};

          itemToAdd.forEach((element)=> {
           const rowItem = rows.find( row => row.imageOfferRowId === element.imageOfferRowId);

           const order = rowItem?.elements.findIndex(el => el.imageId === element.imageId);

            const files = renamedFile(element);
                  formData.append(`images`, files);

            offerCustom.itemsToAdd.push({
                imageId: element.imageId,
                colSize: element.colSize,
                imageSizeType: element.imageSizeType,
                parentImageId: element.parentImageId,
                isMobileVersion: element.isMobileVersion,
                rowId: element.imageOfferRowId,
                order: order
            });
          });
        
          // 2. Añadir las imágenes y sus metadatos
          rowsToAdd.forEach((rowItem) => {

            // Inicializamos el objeto para cada fila
            const rowData: any = { rowNumber: 0, offerItems: [] };

            const rowFromnewIndex = rowsModified.find(m => m.rowId === rowItem.imageOfferRowId);
            const rowFromfindIndex= rows.findIndex(m => m.imageOfferRowId === rowItem.imageOfferRowId);

            if (rowFromnewIndex) {
              rowData.rowNumber = rowFromnewIndex.newIndex;
            } else {
              // Si no se encontró, puedes dejar un valor por defecto
              rowData.rowNumber = rowFromfindIndex; // o el índice actual de rowItem si lo tienes
            }
             
            rowItem.elements.forEach((element) => {
                if (element.imageUrl) {

                  
                  
                  const files = renamedFile(element);
                  formData.append(`images`, files);

                  rowData.offerItems.push({
                    imageId: element.imageId,
                    colSize: element.colSize,
                    imageSizeType: element.imageSizeType,
                    parentImageId: element.parentImageId,
                    isMobileVersion: element.isMobileVersion,
                });

              }
            });
           offerCustom.rowsToAdd.push(rowData);
          });
          
          rowsModified.forEach((rowItem)=>{
            offerCustom.rowsModified.push({
              rowId: rowItem.rowId,
              rowNumber: rowItem.newIndex
            });
          });
          itemsModified.forEach((item)=>{
            offerCustom.itemsModified.push({
              itemId: item.itemId,
              rowId: item.rowId,
              order: item.newIndex
            });
          });


          formData.append("LayoutChanges", JSON.stringify(offerCustom));

          console.log("Datos a enviar:", Array.from(formData.entries()));

          const updateForm = await updateOfferImages(Number(id), formData);
           if(updateForm===true){
              showSuccess("Se actualizo", "Se Actualizaron con éxito!");
              setTimeout(() => {
                  window.location.reload();
              }, 2000);

          } else {
              showError("Error al actualizar", "No se pudo actualizar!");
          }
          
            
          
        }else{


          const offerCustom: any[] = [];
        
          // 2. Añadir las imágenes y sus metadatos
          rows.forEach((rowItem) => {

            // Inicializamos el objeto para cada fila
            const rowData: any = { offerItems: [] };

            
            
            rowItem.elements.forEach((element) => {
                if (element.imageUrl) {

                  const extension = element.imageUrl.name.split('.').pop();
                  const renamedFile = new File(
                    [element.imageUrl],
                    `${element.imageId}.${extension}`,
                    { type: element.imageUrl.type }
                  );
                  formData.append(`images`, renamedFile);

                  

                  rowData.offerItems.push({
                    imageId: element.imageId,
                    colSize: element.colSize,
                    imageSizeType: element.imageSizeType,
                    parentImageId: element.parentImageId,
                    isMobileVersion: element.isMobileVersion
                });

              }
            });
            offerCustom.push(rowData);
          });
        

          formData.append("Rows", JSON.stringify(offerCustom));


          // Aquí puedes enviar formData a tu API
          console.log("Datos a enviar:", Array.from(formData.entries()));

          const AddForm = await createOffer(formData);
          //const AddForm = await {};
            
          if (AddForm){
            showSuccess("Se registro", "Se ha creado con éxito!");
            setTimeout(() => {
                return navigate(`/type-offers`);
            }, 2000);
        
          } else {
            showError("Error al crear", "No se pudo crear!");
          }
        }
    };



    const [listObtained, setListObtained] = useState<Products[]>([]);
    const [productObtained, setProductObtained] = useState<Product | undefined>(
        {
            productId: 0,
            productName: "",
            mainImage: "",
            salePrice: 0,
            discountPrice: 0,
        }
    );
    const [bannerType, setbannerType] = useState(0);
    const [isListProduct, setIsListProduct] = useState(true);

    const [totalItems, setTotalItems] = useState(0);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');
    const [pageSize, setPageSize] = useState(10);

    const [selectedProducts, setSelectedProducts] = useState<Number[]>([]);
    const [delectedProducts, setDelectedProducts] = useState<Number[]>([]);
    const [selectedProduct, setSelectedProduct] = useState<number>(0);

    const [itemIdModal, setItemIdModal] = useState<number>(0);
    const [itemNameModal, setItemNameModal] = useState<string | undefined>("");
    const [itemImageModal, setItemImageModal] = useState<any>();

  const loadProducts = async (page: number, size: number, search: string = '') => {
    const result = await getProducts(page, size, search);
    setTotalItems(result.totalCount);
  };

  useEffect(() => {

      console.log("Products", products);

      loadProducts(page, pageSize, search); 
  }, [page, pageSize, search]);

  useEffect(() => {
        console.log("selectedProducts", selectedProducts);
        console.log("delectedProducts", delectedProducts);
        
    }, [selectedProducts, delectedProducts]);

    useEffect(() => {
        console.log("selectedProduct", selectedProduct);
        
    }, [selectedProduct]);

    useEffect(() => {
        if (itemIdModal) {
            fetchAndSetData();
        }
    }, [itemIdModal]);

    

  const dataModal =  (data: Element )=> {

    if(data){
      setbannerType(data.typeOffer);
      setItemIdModal(data.id);
      setItemNameModal(data.imageUrl?.name);
      setItemImageModal(data.imageUrl);
      setVisibleModal(true);
      // console.log("data de modal: ", data.imageUrl?.type);
      // console.log("data de modal: ", data.imageUrl?.name);
    }
  }

  const fetchAndSetData = async () => {
      try {
          // 1. Obtener datos del producto
            const data = await getOfferItemSliderById(itemIdModal) as OfferItemSlider;
            //const data = await {};

            if (data) {
          
            console.log("data obtenida", data);
          }
          
          if (!data) {
              throw new Error("No se encontraron datos");
          }
          

          // if(!data.products){
          //     throw new Error("Error al obtener productos");
          // }

          setListObtained(data.products ?? []);
          setProductObtained(data.product);
          

      } catch (error) {
          console.error("Error en fetchAndSetImage:", error);
          // Mostrar notificación al usuario
          showError('Error','No se pudieron los datos');
      }
  };

  const saveProductListAndSingle = async () => {
   

      let customData = {productsToAdd:[] as Number[], detailsToRemove:[] as Number[]};

      if(selectedProducts.length>0){

        if (selectedProducts) {
          selectedProducts.forEach((idPro: Number) => customData.productsToAdd.push(idPro));
        }
        if (delectedProducts) {
          delectedProducts.forEach((idPro: Number) => customData.detailsToRemove.push(idPro));
        }

        const updateForm = await updateOfferList(itemIdModal, customData);
      

        if(updateForm===true){
            showSuccess("Se Actualizo", "Se Actualizaron con éxito!");
            setTimeout(() => {
                  window.location.reload();
              }, 2000);

        } else {
            showError("Error al Actualizar", "No se pudo actualizar!");
        }

      }

      let data = {productId: selectedProduct as number};
      
      if(selectedProduct>0) {
        
        console.log(selectedProduct);
        

        const updateForm = await updateOfferSingle(itemIdModal, data);
        if(updateForm===true) {
          showSuccess("Se actualizo", "Se Actualizaron con éxito!");
           setTimeout(() => {
                  window.location.reload();
            }, 2000);

        } else {
            showError("Error al actualizar", "No se pudo actualizar!");
        }
      }

    
  };

  const headerElement = (
    <div className="d-flex inline-flex align-items-center justify-content-center gap-2">
      {itemImageModal && 
        <img src={  URL.createObjectURL(itemImageModal as File)} alt="alt" className='img-modal' />
      }
      {/* <span className="font-bold white-space-nowrap">{itemNameModal}</span> */}
    </div>
  );

  const footerContent = (
    <div>
      <Button className='btn btn-dark' type='button' label="Guardar" icon="pi pi-check" onClick={() => {setVisibleModal(false); saveProductListAndSingle()}} autoFocus />
    </div>
  );

  return (
    <>
       <Dialog visible={visibleModal} modal header={headerElement} footer={footerContent} style={{ width: '60vw' }} onHide={() => {if (!visibleModal) return; setVisibleModal(false); }}>
          <>
             <div className='row mt-3'>
                <div className='col-lg-12 content-btn-options mb-2'>
                    {bannerType===1 && (
                            <>
                                <h3>Actulizar un producto</h3>
                            </>
                    )}
                    {bannerType===2 && (
                            <>
                                <h3>Actualizar Productos</h3>
                            </>
                    )}
                    {bannerType===3 && (
                            <>
                                <button className={`btn btn-dark ${isListProduct ? "is-list-product": ""}`} onClick={()=>{setIsListProduct(true);setSelectedProduct(0) }} >Añadir Productos</button>
                                <button className={`btn btn-dark ${!isListProduct ? "is-list-product": ""}`} onClick={()=>{setIsListProduct(false);setSelectedProducts([]);setDelectedProducts([]) }} >Añadir URL de un producto</button>
                            </>
                    )}
                </div>
                <div className='col-lg-12'>
                    <div  className="card pt-3">
                        
                        {bannerType===1 && (
                            <CustomOrderList
                            data={products}
                            pageSize={10}
                            sourceSearchValue={search}
                            sourcePage={page + 1}
                            sourceTotalCount={totalItems}
                            onSourceSearchChange={(value) => {
                                setSearch(value);
                                setPage(0);
                                loadProducts(0, 5, value);
                            }}
                            onSourcePageChange={(newPage) => {
                                setPage(newPage - 1);
                                loadProducts(newPage - 1, 5, search);
                            }}
                            onChange={(id) => {
                                setSelectedProduct(id);
                            }}
                            ProductObtained={productObtained}
                        />
                        )}
                        {bannerType===2 && (
                            
                        <CustomPickList
                            data={products}
                            pageSize={10}
                            sourceSearchValue={search}
                            sourcePage={page + 1}
                            sourceTotalCount={totalItems}
                            onSourceSearchChange={(value) => {
                                setSearch(value);
                                setPage(0);
                                loadProducts(0, 5, value);
                            }}
                            onSourcePageChange={(newPage) => {
                                setPage(newPage - 1);
                                loadProducts(newPage - 1, 5, search);
                            }}
                            onChange={(selectedIds, deletedIds) => {
                                setSelectedProducts(selectedIds);
                                setDelectedProducts(deletedIds);
                            }}
                            listObtained={listObtained}
                        />
                        )}

                        {bannerType===3 && (
                            <>
                                    {isListProduct && (
                                    <CustomPickList
                                        data={products}
                                        pageSize={10}
                                        sourceSearchValue={search}
                                        sourcePage={page + 1}
                                        sourceTotalCount={totalItems}
                                        onSourceSearchChange={(value) => {
                                            setSearch(value);
                                            setPage(0);
                                            loadProducts(0, 5, value);
                                        }}
                                        onSourcePageChange={(newPage) => {
                                            setPage(newPage - 1);
                                            loadProducts(newPage - 1, 5, search);
                                        }}
                                        onChange={(selectedIds, deletedIds) => {
                                            setSelectedProducts(selectedIds);
                                            setDelectedProducts(deletedIds);
                                        }}
                                        listObtained={listObtained}
                                    />
                                )}
                                {!isListProduct && (
                                    <CustomOrderList
                                        data={products}
                                        pageSize={10}
                                        sourceSearchValue={search}
                                        sourcePage={page + 1}
                                        sourceTotalCount={totalItems}
                                        onSourceSearchChange={(value) => {
                                            setSearch(value);
                                            setPage(0);
                                            loadProducts(0, 5, value);
                                        }}
                                        onSourcePageChange={(newPage) => {
                                            setPage(newPage - 1);
                                            loadProducts(newPage - 1, 5, search);
                                        }}
                                        onChange={(id) => {
                                            setSelectedProduct(id);
                                        }}
                                        ProductObtained={productObtained}
                                    />
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
          </>
      </Dialog>
      <div className="block-header">
        <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12 text-start">
                <h2>Ofertas y promociones</h2>
                <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a href="/home" className="text-danger"><FontAwesomeIcon icon={icon({name: 'home'})} /></a>
                    </li>
                    <li className="breadcrumb-item">
                        <a href="/type-offers" className="text-danger">Tipo de ofertas</a>
                    </li>
                    <li className="breadcrumb-item">{title}</li>
                </ul>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="d-flex flex-row-reverse">
                    
                    <div className="p-2 d-flex">
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div className="row">
          <div className='title-report'>
          {title}
          </div>
      </div>
      {/* <Toast ref={toast} /> */}
      <form onSubmit={handleSubmit} encType="multipart/form-data" className="row builder-container">
        <div className={`${previousViewState ? 'col-lg-12' : 'col-lg-9'}`}>
          {!previousViewState &&
          
            <div className="form-text-fields mb-4">
              <div className="form-group mb-2">
                <label className="mb-2" htmlFor="title">Título</label>
                <input
                  type="text"
                  id="title"
                  className="form-control"
                  value={titleInput}
                  onChange={(e) => setTitleInput(e.target.value)}
                  placeholder="Ingrese el título principal"
                />
              </div>
              <div className="form-group mb-2">
                <label className="mb-2" htmlFor="subtitle">Subtítulo</label>
                <input
                  type="text"
                  id="subtitle"
                  className="form-control"
                  value={subtitleInput}
                  onChange={(e) => setSubtitleInput(e.target.value)}
                  placeholder="Ingrese un subtítulo"
                />
              </div>
            </div>
          }
         
          {previousViewState ?
            <>
              <div className='d-flex justify-content-center p-2'>
                <button type="button" className={`${  screenMode===screenModeType.WEB ?  "btn btn-info" : "btn btn-default"}`} onClick={()=>{setScreenMode(screenModeType.WEB)}}><FontAwesomeIcon icon={icon({name: 'desktop'})} /></button>
                <button type="button" className={`${  screenMode===screenModeType.MOBILE ?  "btn btn-info" : "btn btn-default"} ms-1`} onClick={()=>{setScreenMode(screenModeType.MOBILE)}}><FontAwesomeIcon icon={icon({name: 'mobile-screen'})} /></button>
              </div>
              <section>

                { screenMode===screenModeType.WEB &&
                   
                  <>
                    {rows?.map((row, rowIndex)=>(
                        <>
                          {/* <div>Fila {rowIndex}</div> */}
                          <div key={rowIndex} className='row'>
                          
                            {row.elements?.map((element: any, index: number) => (
                                <div key={`${element.imageId}-${index}-web`} className={`${element.colSize} mb-3`}>
                                  
                                    {element.imageUrl ? (
                                        <>
                                          <img
                                              src={URL.createObjectURL(element.imageUrl)}
                                              alt="Imagen personalizada"
                                              className={`${element.isMobileVersion===true ? "d-none" : "img-element"}`}
                                            />
                                        </>
                                    ) : (
                                        <>
                                          <div className={`${element.isMobileVersion===true ? "d-none" : "box-view d-flex"}`} >
                                            <h5>{element.sizeName}</h5>
                                          </div>
                                        </>
                                    )}
                                </div>
                              ))}
                          </div>
                        </>
                    ))}
                    
                  </>
                }
                
                { screenMode===screenModeType.MOBILE &&
                  <>

                    { rows.map((row, rowIndex)=>(
                      <>
                        {/* <div>Fila {rowIndex}</div> */}
                        <div key={rowIndex} className='row  row-mobile-slider'>
                          {row.elements?.map((element: any, index: number) => {
                            const ec44Elements = row.elements?.filter(el => el.imageSizeType === ImageSizeType.EC44) || [];

                          //const groupedEc44 = [...ec44Elements];
                            // const groupedEc44 = [];
                            
                            // for (let i = 0; i < ec44Elements.length; i += 2) {
                            //   groupedEc44.push(ec44Elements.slice(i, i + 2));
                            // }
                            const firstIndex = row.elements?.findIndex(el => el.imageSizeType === ImageSizeType.EC44);
                            const lastIndex = row.elements?.map((el, i) => ({ el, i }))
                              .filter(({ el }) => el.imageSizeType === ImageSizeType.EC44)
                              .pop()?.i;

                            const getContainerClass = () => {
                              if (ec44Elements.length === 4) {
                                return 'slider-content400x400_1';
                              }
                              if (ec44Elements.length === 2) {
                                if (firstIndex === 0 && lastIndex === 2) {
                                  return '';
                                }
                                else{
                                  return 'slider-content400x400_2';
                                }
                              }
                              return 'slider-content400x400_2';
                            };
                            const getItemClass = () => {
                              if (ec44Elements.length === 4) {
                                return 'img-element-slider';
                              }
                              if (ec44Elements.length === 2) {
                                if (firstIndex === 0) {
                                  return 'item-two-start';
                                }
                                if (lastIndex === 2) {
                                  return 'item-two-end';
                                }
                              }
                              return 'box-view d-flex';
                            };

                            // console.log("groupedEc44", groupedEc44);

                            // console.log(firstIndex, lastIndex);
                            // console.log("ec44Elements", ec44Elements);
                              return(
                                <>
                                  {element.imageSizeType === ImageSizeType.EC44 && (
                                    <>
                                    
                                      <div className={getContainerClass()} >
                                        <div  key={`${element.imageId}-${index}-${ImageSizeType.EC44}`} className="col-lg-12 mb-3">
                                          { element.imageUrl ? (
                                                <>
                                                  <img
                                                      src={URL.createObjectURL(element.imageUrl)}
                                                      alt="Imagen personalizada"
                                                      className={getItemClass()}
                                                  />
                                                </>
                                            ) : (
                                              <>
                                                <div className={`box-view d-flex`}>
                                                  <h5>{element.sizeName}</h5>
                                                </div>
                                              </>
                                            )}
                                        </div>
                                      </div>
                                    </>
                                  )}

                                  {element.imageSizeType === ImageSizeType.EC66 &&
                                  
                                    <>
                                      
                                  
                                      <div className='slider-content600x600'>
                                        <div  key={`${element.imageId}-${index}-${ImageSizeType.EC66}`} className="col-lg-12 mb-3">
                                          {element.imageUrl ? (
                                                <>
                                                  <img
                                                      src={URL.createObjectURL(element.imageUrl)}
                                                      alt="Imagen personalizada"
                                                      className={`${element.isMobileVersion===false ? "img-element-slider" : "d-none"}`}
                                                  />
                                                </>
                                            ) : (
                                              <>
                                                <div className={`${element.isMobileVersion===false ? "box-view d-flex" : "d-none"}`}>
                                                  <h5>{element.sizeName}</h5>
                                                </div>
                                              </>
                                            )}
                                        </div>
                                      </div>
                                  
                                  
                                    </>
                                  }
                                
                                  {(element.imageSizeType === ImageSizeType.ER84) &&
                                  
                                    <div  key={`${element.imageId}-${index}-${ImageSizeType.ER84}`} className="col-lg-12 mb-3">

                                      {element.imageUrl ? (
                                          <>
                                            <img
                                                src={URL.createObjectURL(element.imageUrl)}
                                                alt="Imagen personalizada"
                                                className={`${element.isMobileVersion===false ? "img-element" : "d-none"}`}
                                            />
                                          </>
                                      ) : (
                                        <>
                                          <div className={`${element.isMobileVersion===false ? "box-view d-flex" : "d-none"}`}>
                                            <h5>{element.sizeName}</h5>
                                          </div>
                                        </>
                                      )}

                                    </div>
                                  }
                                  {(element.imageSizeType === ImageSizeType.ER14) &&
                                  
                                    <div  key={`${element.imageId}-${index}-${ImageSizeType.ER14}`} className="col-lg-12 mb-3">

                                      {element.imageUrl ? (
                                          <>
                                            <img
                                                src={URL.createObjectURL(element.imageUrl)}
                                                alt="Imagen personalizada"
                                                className={`${element.isMobileVersion===true ? "img-element" : "d-none"}`}
                                            />
                                          </>
                                      ) : (
                                        <>
                                          <div className={`${element.isMobileVersion===true ? "box-view d-flex" : "d-none"}`}>
                                            <h5>{element.sizeName}</h5>
                                          </div>
                                        </>
                                      )}

                                    </div>
                                  }
                                </>
                              )
                            })}
                        </div>
                      </>

                    ))}

                   
                  </>
                }
              </section>
              
            </>
          :
            <>
                {rows.length === 0 ? (
                  <div className="drop-zone-placeholder">
                    <FontAwesomeIcon icon={icon({name: 'image'})} size="2x" />
                    <p>Arrastra elementos aquí para crear la primera fila</p>
                  </div>
                ) : (
                  <div className="rows-container">
                    {rows?.map((row, rowIndex) => {
                      const totalSize = row.elements.reduce((acc, element) => acc + Number(element.numberSize || 0), 0);
                      return (

                        <div key={row.imageOfferRowId}
                         ref={dropZoneRef}
                          onDragStart={(e) => handleTargetDragStartRow(e, row)}
                          onDragOver={(e) => handleDragOverRow(e, rowIndex)}
                          //onDragOver={(e) => e.preventDefault()}
                        draggable
                        className={`drop-zone ${draggedItem ? 'drop-zone-active' : ''} row-container mb-4`}
                          onDrop={(e) => handleDrop(e, totalSize, row.imageOfferRowId, )}
                      >
                         <div className="row-header d-flex justify-content-end align-items-center p-2 bg-light">
                          {/* <span>Fila {rowIndex + 1}</span> */}
                          <button
                            type='button'
                            className="btn btn-sm btn-danger"
                            onClick={() => removeRow(row.imageOfferRowId ?? "")}
                          >
                            <FontAwesomeIcon icon={icon({name: 'trash'})} />
                          </button>
                        </div>

                         <div className="row">
                          {Array.isArray(row?.elements) ? (
                            row.elements.map((element, elementIndex) => {
  
                              return (
                                  <div
                                      key={`${element.imageId}-${elementIndex}`}
                                      draggable
                                      onDragStart={(e) => handleTargetDragStart(e, element)}
                                      onDragOver={(e) => handleDragOverElement(e, elementIndex)}
                                      onDragLeave={handleDragLeaveElement}
                                      className={`${element.imageSizeType === ImageSizeType.ER14
                                        ? element.isMobileVersion===true ? "col-lg-4" : "col-lg-8"
                                        : element.colSize}
                                        mb-4 element-container ${dragOverIndexElement === elementIndex ? 'drop-highlight' : ''}
                                        `}
                                    >
                                      
                                      {/* {totalSize} */}
                                        <div className="element-content">
                                          <div
                                            className="dropzone"
                                            onClick={() => elementInputRefs.current[row.imageOfferRowId ?? ""]?.[elementIndex]?.click()}
                                            
                                            onDrop={(e) => {
                                              handleDropImage(e, elementIndex, row.imageOfferRowId,  element.imageId);
                                              setIsDraggingElements(false);
                                            }}
                                            onDragOver={(e) =>{
                                              e.preventDefault();
                                              e.dataTransfer.dropEffect = 'copy';
                                            }}
                                            onDragEnter={() => setIsDraggingElements(true)}
                                            onDragLeave={() => setIsDraggingElements(false)}
                                            >
                                            {element.imageUrl  ? (
                                                    <img
                                                    src={URL.createObjectURL(element.imageUrl)}
                                                    alt="Imagen personalizada" 
                                                    className={` img-element ${element.typeOffer===3 && "typeOffer-none"} ${element.typeOffer===2 && "typeOffer-list"} ${element.typeOffer===1 && "typeOffer-single"}`} 
                                                  />
                                            ) : (
                                                <>
                                                {element.isMobileVersion===true
                                                ?
                                                  <>
                                                    <h5>Imagen para dispositivo mobile</h5>
                                                    <span>Haz clic o arrastra aquí</span>
                                                    <span>{element.description}</span>
                                                  </>
                                                :
                                                  <>
                                                    <h5>{element.sizeName}</h5>
                                                    <span>Haz clic o arrastra aquí</span>
                                                    <span>{element.description}</span>
                                                  </>
                                                }
                                                </>
                                            )}
                                            <input
                                                ref={(el) => {
                                                  if (!elementInputRefs.current[row.imageOfferRowId ?? ""]) {
                                                    elementInputRefs.current[row.imageOfferRowId ?? ""] = [];
                                                  }
                                                  elementInputRefs.current[row.imageOfferRowId ?? ""][elementIndex] = el;
                                                }}
                                                type="file"
                                                accept="image/*"
                                                style={{ display: "none" }}
                                                onChange={(e) => {handleImageChange(e, elementIndex, String(row.imageOfferRowId), element.imageId); element.id!=null && updateItemImage(e, element )}}
                                            />
                                          </div>
                                          {!element.isMobileVersion &&
                                            <>
                                              <div className="element-actions">
                                                <button
                                                  type='button'
                                                  className="btn btn-danger btn-sm"
                                                  onClick={() => removeElement(row.imageOfferRowId ?? "", element.imageId, element.id)}
                                                >
                                                  <FontAwesomeIcon icon={icon({name: 'trash'})} />
                                                </button>
                                              </div>
                                              {(element.imageUrl && element.id!=null && id) && 
                                              
                                                <div>
                                                  <Button  className="btn btn-dark mt-2" type='button' label="Asignar" icon="pi pi-images" onClick={() =>  dataModal(element)} />
                                                </div>
                                              }
                                            </>
                                          }
                                          
                                          
                                        </div>
                                      
                                  </div>

                              )})
                          ) : (
                            <div>No hay elementos en esta fila</div> // O manejar el caso de error
                          )}
                        </div>
                      

                        {/* <RowComponent  row={row} /> */}
                        </div>

                      )
                    }
                      
                      
                     
                    )}
                  </div>
                )}
                
                <button 
                  type="button" 
                  className="btn btn-primary mt-3"
                  onClick={addRow}
                >
                  <FontAwesomeIcon icon={icon({name: 'plus'})} /> Añadir Fila
                </button>
            </>
          }
        </div>
        {/* Panel de elementos */}
        {!previousViewState &&
            <div className="col-lg-3 elements-panel">
              <div className="elements-list content-element-piece">
                <h4 className='mt-4'>Elementos disponibles</h4>
                {elementsOb.map(element => (
                  <div
                    key={element.id}
                    draggable
                    onDragStart={(e) => handleDragStart(element, e)}
                    className="draggable-item-piece"
                  >
                    <div className="element-preview">
                      <div className='element-piece'>
                        <div className='box' style={{height: element.sizeWidth}}>
                          <div className="element-info">
                            <h5>{element.sizeName}</h5>
                          </div>
                        </div>
                      </div>
                      
                    </div>
                  </div>
                ))}
              </div>
            </div> 
        }
        <div className='btn-float-content'>
          <button type="button" className="btn btn-info" onClick={()=>{setPreviousViewState(!previousViewState);setScreenMode(screenModeType.WEB)}}><FontAwesomeIcon icon={icon({name: 'eye'})} /></button>
          {/* <button type="submit" disabled={previousViewState? true : canSave ? true: false} className="btn btn-dark ms-2">Guardar</button> */}
          <button type="submit" disabled={canSave} className="btn btn-dark ms-2">Guardar</button>
        </div>
      </form>
    </>
  );
};